import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import Icon from "../components/Icons";
import CtaBand from "../components/CtaBand";
import ServiceArt from "../components/ServiceArt";
import styles from "./CategoryPage.module.css";
import { categories, servicesByCategory } from "../data/services";

/**
 * Osteopathy, Oriental Medicine and Fitness are each one page listing
 * their modalities. Every modality gets an id so it can be deep-linked
 * from the homepage grid or an external reference.
 */
export default function CategoryPage({ categoryKey, tone = "light" }) {
  const category = categories[categoryKey];
  const items = servicesByCategory(categoryKey);

  return (
    <>
      <PageHeader
        eyebrow={category.label}
        title={category.title}
        lead={category.lead}
        tone={tone}
      />

      <section className={`u-section ${styles.section} ${styles[tone]}`}>
        <div className="u-shell">
          <ul className={styles.list}>
            {items.map((item, i) => (
              <Reveal
                as="li"
                key={item.slug}
                id={item.slug}
                delay={Math.min(i, 4) * 80}
                className={`${styles.item} ${
                  item.featured ? styles.featured : ""
                }`}
              >
                <div className={styles.itemBody}>
                  <div className={styles.head}>
                    <span className={styles.icon}>
                      <Icon name={item.icon} size={26} />
                    </span>
                    <div className={styles.headCopy}>
                      <h2 className={styles.title}>{item.title}</h2>
                      <p className={styles.short}>{item.short}</p>
                    </div>
                  </div>

                  <p className={styles.intro}>{item.intro}</p>

                  {item.helps?.length > 0 && (
                    <>
                      <h3 className={styles.helpsTitle}>Commonly used for</h3>
                      <ul className={styles.helps}>
                        {item.helps.map((h) => (
                          <li key={h}>{h}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>

                {item.featured && (
                  <div className={styles.itemArt}>
                    <ServiceArt
                      art={item.art}
                      src={item.image}
                      alt={item.imageAlt || ""}
                      tone={tone}
                    />
                  </div>
                )}
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
